import UrlPattern from 'url-pattern';
import { renting, rentingOut } from 'ha/constants/HowItWorksUrls';
import { Language } from '@ha/intl';
import {
  AnswersSupportedLangs,
  ContentfulSupportedLangs,
} from 'ha/modules/Hermes/constants';
import { PaymentsUrls } from 'ha/pages/Payments/constants';
import {
  globalReach,
  easyPropertyManagement,
  integrations,
  securePayments,
  superiorMatching,
  smartSearch,
  onlineViewing,
  directMessaging,
} from 'ha/pages/Feature/constants';

export const marketingPages = [
  renting,
  rentingOut,
  ...Object.values(PaymentsUrls),
  globalReach,
  easyPropertyManagement,
  integrations,
  securePayments,
  superiorMatching,
  smartSearch,
  onlineViewing,
  directMessaging,
];

const languageUrls = (lang: Language) => marketingPages.map(page => page[lang]);

export const getMarketingPageIndex = (slug: string, lang: Language) =>
  languageUrls(lang).indexOf(`/${slug}`);

export const getMarketingPageUrl = (pageIndex: number, lang: Language) =>
  languageUrls(lang)[pageIndex];

const getAnswersPageUrl = (link: string, lang: Language) => {
  const answersMatchPattern = new UrlPattern(
    '(http(s)\\://)answers.housinganywhere.:tld(/*)',
  );

  if (
    !AnswersSupportedLangs.includes(lang) ||
    !answersMatchPattern.match(link)
  ) {
    return undefined;
  }

  return link.replace(`/${Language.en}/`, `/${lang}/`);
};

export const getSubPageUrl = (link: string | undefined, lang: Language) => {
  const myMatchPattern = new UrlPattern('(/:lang/)my(/*)');
  if (
    !link ||
    ContentfulSupportedLangs.includes(lang) ||
    Boolean(myMatchPattern.match(link))
  ) {
    return link;
  }

  const answersPageUrl = getAnswersPageUrl(link, lang);
  if (answersPageUrl) {
    return answersPageUrl;
  }

  const pageIndex = getMarketingPageIndex(link, Language.en);
  if (pageIndex >= 0) {
    return getMarketingPageUrl(pageIndex, lang).substring(1);
  }

  return undefined;
};

export const getMarketingPage = (pathname: string, lang: Language) => {
  const decodedPathname = decodeURIComponent(pathname);
  const slug = decodedPathname.substring(decodedPathname.lastIndexOf('/') + 1);
  const marketingPageIndex = getMarketingPageIndex(slug, lang);

  return {
    isMarketingPage: marketingPageIndex >= 0,
    marketingPageIndex,
    decodedPathname,
    slug,
  };
};
